let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aCxkT")).then(() => parcelRequire('zxxsp'));